module.exports = "\r\n    \r\n        <div class=\"page-not-found \">\r\n            <div class=\"page-not-found-content\">\r\n                    <h1>4O4</h1>\r\n                    <p>Oops, Page you are looking for is not found!</p>\r\n                    <a class=\"btn btn-404\" href=\"/\">Go To Home</a>\r\n           </div>\r\n        </div>\r\n  \r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/pageNotFound/page-not-found.component.html
// module id = ../../../../../app/shared/components/pageNotFound/page-not-found.component.html
// module chunks = main